import React from "react";
import { Link } from "react-router-dom";
import banner from "../assets/banner.jpg";
import "./Banner.css";

const Banner = () => {
  return (
    <div className="banner">
      <div className="banner-content">
        <img className="banner-img" src={banner} alt="banner" />
      </div>
      <div className="content">
        <p>
          Hi, my name is Dave Shea and i am a full stack developer specializing
          in:
        </p>
        <h1>React, Javascript & Nodejs</h1>
        <div>
          <Link className="btn" to="/projects">
            Projects
          </Link>
          <Link className="btn btn-light" to="/contact">
            Contact
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Banner;
